import '../services.orders';
import '../services.pnotify';
import '../services.product_review_comment';
import '../services.image';
import '../services.feature';
import { PRODUCT_REVIEW_REWARD_TYPE } from '../../constants/productReview';
import dayjs from 'dayjs';
import { getConditionCaseNumber } from './utils/getConditionCaseNumber';

const FORM_STATE = {
  INITIAL: 'initial',
  EMPTY: 'empty',
  EDITING: 'editing',
  INVALID: 'invalid',
  SUBMITTED: 'submitted',
};

const PRODUCT_TYPE = {
  PRODUCT_SET: 'ProductSet',
  PRODUCT: 'Product',
};

app.directive('productReviewCommentsForm', [
  '$http',
  'imageService',
  'staticResourceHost',
  'mainConfig',
  'productReviewCommentService',
  'pnotifyService',
  'ordersService',
  '$filter',
  'featureService',
  '$uibModal',
  function (
    $http,
    imageService,
    staticResourceHost,
    mainConfig,
    productReviewCommentService,
    pnotifyService,
    ordersService,
    $filter,
    featureService,
    $uibModal,
  ) {
    return {
      restrict: 'E',
      templateUrl: require('../../../../../../public/themes/shared/product_review_comments/templates.product_review_comments_form.html'),
      scope: {
        currentOrderId: '=',
        allowUploadMedia: '=',
        productReviewRewardType: '=',
        productReviewRewardRule: '=',
      },
      link: function ($scope) {
        $scope.FORM_STATE = FORM_STATE;
        $scope.staticResourceHost = staticResourceHost;
        $scope.imageService = imageService;
        $scope.ordersService = ordersService;
        $scope.isRecaptchaEnabled = mainConfig.isRecaptchaEnabled;
        $scope.formState = FORM_STATE.INITIAL;
        $scope.state = {
          isSendingComment: false,
        };
        $scope.hasProductReviewRewardConditions = featureService.hasFeature(
          'product_review_reward_conditions',
        );

        const getProductReviewRewardConfig = () => {
          productReviewCommentService
            .getProductReviewRewardConfig()
            .then(({ reviewRewardCondition }) => {
              $scope.reviewRewardCondition = reviewRewardCondition;
            });
        };
        getProductReviewRewardConfig();

        const getOrder = function (orderId) {
          productReviewCommentService
            .getOrder(orderId)
            .then(function (response) {
              $scope.currentOrder = response.data;
              $scope.currentOrder.subtotal_items = filterOrderSubtotalItems(
                response.data.subtotal_items,
              );
              initFormData($scope.currentOrder);
            });
        };

        const checkDuplicatedProduct = (list, product) => {
          if (product.item_type === PRODUCT_TYPE.PRODUCT_SET) {
            return list.find((item) => item.item_id === product.item_id);
          }
          if (product.item_type === PRODUCT_TYPE.PRODUCT) {
            return list.find(
              (item) => item.object_data._id === product.object_data._id,
            );
          }
          return true;
        };

        const filterOrderSubtotalItems = (subtotalItems) => {
          return subtotalItems.reduce((result, currentItem) => {
            // POS exchange order, there will be both negative and positive quantity item
            if (currentItem.quantity < 0) {
              return result;
            }
            const isDuplicatedProduct = checkDuplicatedProduct(
              result,
              currentItem,
            );

            if (isDuplicatedProduct) {
              return result;
            }

            return result.concat([currentItem]);
          }, []);
        };

        const initFormData = function (order) {
          if (order.subtotal_items.length === 0) {
            $scope.formState = FORM_STATE.EMPTY;
            return;
          }

          $scope.formState = FORM_STATE.EDITING;
          $scope.productReviewComments = order.subtotal_items.map(
            function (item) {
              return {
                score: 0,
                comment: '',
                product_id: item.object_data._id,
                medias: [],
              };
            },
          );
          // focus a textarea on mobile devices to make it scroll to the form
          const textarea = document.getElementsByTagName('textarea')[0];
          if (textarea) {
            textarea.focus();
          }
        };

        $scope.$watch('currentOrderId', function (newValue) {
          getOrder(newValue);
        });

        $scope.submitForm = function () {
          const invalidComment = $scope.productReviewComments.some(
            function (comment) {
              return comment.score == 0;
            },
          );
          if (invalidComment) {
            $scope.formState = FORM_STATE.INVALID;
            return;
          }

          if ($scope.state.isSendingComment) {
            return;
          }

          $scope.state.isSendingComment = true;

          const payload = {
            user_id: mainConfig.currentUser._id,
            order_id: $scope.currentOrder._id,
            product_review_comments: $scope.productReviewComments.map(
              function (formData) {
                return {
                  score: formData.score,
                  comment: formData.comment,
                  product_id: formData.product_id,
                  media_ids: formData.medias.map(function (media) {
                    return media._id;
                  }),
                };
              },
            ),
          };
          $http({
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            url:
              '/api/merchants/' +
              mainConfig.merchantId +
              '/orders/' +
              $scope.currentOrder._id +
              '/product_review_comments/bulk',
            data: payload,
          })
            .then(function () {
              $scope.formState = FORM_STATE.SUBMITTED;
            })
            .catch(function (err) {
              pnotifyService.notify(err.data.error, {
                customClass: 'error',
                icon: 'fa fa-exclamation-triangle',
              });
            })
            .finally(function () {
              $scope.state.isSendingComment = false;
            });
        };

        $scope.getFinishedReviewDesc = () => {
          switch ($scope.productReviewRewardType) {
            case PRODUCT_REVIEW_REWARD_TYPE.user_credit:
              return $filter('translate')(
                'product_review_comments.orders.finished_review.desc.user_credit',
                {
                  value: $scope.productReviewRewardRule.credit_value,
                },
              );
            case PRODUCT_REVIEW_REWARD_TYPE.member_point:
              return $filter('translate')(
                'product_review_comments.orders.finished_review.desc.member_point',
                {
                  value: $scope.productReviewRewardRule.point_value,
                },
              );
            case null:
              return '';
            default:
              throw Error(
                `unknown productReviewRewardType: ${$scope.productReviewRewardType}`,
              );
          }
        };

        $scope.isReadyToRenderCondition = () => {
          return (
            $scope.productReviewRewardRule &&
            $scope.productReviewRewardType &&
            $scope.currentOrder
          );
        };

        $scope.renderCondition = () => {
          const { credit_value, point_value } = $scope.productReviewRewardRule;
          const type = $scope.productReviewRewardType;
          const value =
            type === PRODUCT_REVIEW_REWARD_TYPE.user_credit
              ? credit_value
              : point_value;
          const translatedType = $filter('translate')(type);

          // return the default description if key off
          if (!$scope.hasProductReviewRewardConditions) {
            return $filter('translate')(
              'product_review_comments.orders.finished_review.desc.1',
              { value, type: translatedType },
            );
          }

          const { min_length, deadline_days } = $scope.reviewRewardCondition;
          const deadline = dayjs($scope.currentOrder.completed_at)
            .add(deadline_days, 'day')
            .format('YYYY/MM/DD');

          const caseNumber = getConditionCaseNumber(
            $scope.reviewRewardCondition,
          );

          return $filter('translate')(
            `product_review_comments.orders.finished_review.desc.${caseNumber}`,
            { deadline, min_length, value, type: translatedType },
          );
        };

        $scope.openModal = function () {
          const newScope = $scope.$new();
          newScope.reviewRewardCondition = $scope.reviewRewardCondition;
          newScope.modalContentItems = [
            {
              svgPath:
                'M16.1668 3.69591C16.4397 3.95062 16.6444 4.2167 16.7808 4.49415C16.9173 4.77161 16.9901 5.05133 16.9991 5.33333C17.0082 5.63353 16.9446 5.9269 16.8081 6.21345C16.6717 6.5 16.4716 6.77973 16.2078 7.05263C16.0804 7.18908 15.571 7.6985 14.6796 8.5809C13.7882 9.46329 12.8262 10.4162 11.7938 11.4396C10.7614 12.463 9.8131 13.4022 8.94896 14.2573C8.08481 15.1124 7.61181 15.5809 7.52994 15.6628C7.50265 15.6901 7.47309 15.7128 7.44125 15.731C7.40941 15.7492 7.3753 15.7628 7.33892 15.7719C7.21157 15.8083 6.94323 15.8925 6.5339 16.0244C6.12456 16.1563 5.70387 16.2904 5.27179 16.4269C4.83972 16.5634 4.45086 16.6884 4.1052 16.8021C3.75954 16.9159 3.58216 16.9727 3.57306 16.9727C3.55487 16.9818 3.53441 16.9886 3.51166 16.9932C3.48892 16.9977 3.46391 17 3.43662 17C3.38204 17 3.32747 16.9886 3.27289 16.9659C3.21831 16.9431 3.17283 16.909 3.13644 16.8635C3.07277 16.809 3.03184 16.7407 3.01364 16.6589C2.99545 16.577 2.99545 16.4951 3.01364 16.4133C3.02274 16.4042 3.07732 16.2336 3.17738 15.9016C3.27744 15.5695 3.39341 15.1852 3.52531 14.7485C3.65721 14.3119 3.78455 13.8866 3.90735 13.4727C4.03015 13.0588 4.11429 12.7609 4.15977 12.5789C4.17797 12.5426 4.19616 12.5084 4.21435 12.4766C4.23254 12.4448 4.25528 12.4152 4.28257 12.3879L8.51233 8.15789C9.5766 7.09356 10.5613 6.10657 11.4663 5.19688C12.3714 4.28719 12.8558 3.80507 12.9195 3.75049C13.0104 3.65952 13.206 3.5117 13.5062 3.30702C13.8064 3.10234 14.1748 3 14.6114 3C14.8934 3 15.164 3.05913 15.4232 3.17739C15.6825 3.29565 15.9303 3.46848 16.1668 3.69591ZM12.783 5.1423C12.3555 5.56076 11.8097 6.10201 11.1457 6.76608C10.4817 7.43015 9.79719 8.11696 9.09222 8.82651C8.38726 9.53607 7.71187 10.2138 7.06603 10.8596L5.52421 12.4016C5.70614 12.4743 5.90853 12.5789 6.13139 12.7154C6.35425 12.8519 6.57938 13.0338 6.80679 13.2612C6.98871 13.4522 7.14107 13.6455 7.26387 13.8411C7.38667 14.0367 7.48446 14.2164 7.55723 14.3801C7.93927 13.998 8.45093 13.4909 9.09222 12.8587C9.73351 12.2264 10.4044 11.5624 11.1048 10.8665C11.8052 10.1706 12.4851 9.49513 13.1446 8.84016C13.8041 8.18518 14.3476 7.64848 14.7751 7.23002C14.766 7.15724 14.7137 6.98668 14.6182 6.71832C14.5227 6.44997 14.3385 6.17934 14.0656 5.90643C13.7927 5.64262 13.538 5.45614 13.3015 5.34698C13.065 5.23782 12.8922 5.16959 12.783 5.1423ZM4.92386 13.1384C4.8238 13.475 4.68508 13.9207 4.50771 14.4756C4.33033 15.0305 4.17797 15.5127 4.05062 15.922C4.47814 15.7856 4.97389 15.6218 5.53786 15.4308C6.10183 15.2398 6.5339 15.0942 6.83407 14.9942C6.78859 14.8577 6.71582 14.6894 6.61576 14.4893C6.5157 14.2891 6.37017 14.0936 6.17914 13.9025C5.92445 13.6478 5.6834 13.4636 5.45599 13.3499C5.22858 13.2362 5.05121 13.1657 4.92386 13.1384ZM15.5665 6.42495C15.7484 6.24301 15.8849 6.06108 15.9758 5.87914C16.0668 5.69721 16.1123 5.52437 16.1123 5.36062C16.1123 5.19688 16.0645 5.02859 15.969 4.85575C15.8735 4.68291 15.7348 4.51007 15.5528 4.33723C15.4073 4.19168 15.2549 4.08252 15.0958 4.00975C14.9366 3.93697 14.7751 3.90058 14.6114 3.90058C14.3294 3.90058 14.0861 3.97336 13.8814 4.11891C13.6767 4.26446 13.5653 4.35088 13.5471 4.37817L13.4789 4.44639C13.6517 4.51917 13.8427 4.62151 14.052 4.75341C14.2612 4.88532 14.4749 5.06043 14.6932 5.27875C14.9025 5.48798 15.0707 5.70175 15.1981 5.92008C15.3254 6.1384 15.4209 6.33853 15.4846 6.52047C15.5028 6.50227 15.5187 6.48408 15.5324 6.46589C15.546 6.44769 15.5574 6.43405 15.5665 6.42495Z',
              title: 'product_review_comments.modal.content.character',
              condition: $scope.reviewRewardCondition.min_length,
              hint: 'product_review_comments.modal.content.character_hint',
              noLimit:
                'product_review_comments.modal.content.no_limit.character',
              params: { min_length: $scope.reviewRewardCondition.min_length },
            },
            {
              svgPath:
                'M4.33333 4.375C5.91667 2.79166 7.80554 2 10 2C12.1945 2 14.0764 2.78471 15.6458 4.35417C17.2153 5.92362 18 7.80554 18 10C18 12.1945 17.2153 14.0764 15.6458 15.6458C14.0764 17.2153 12.1945 18 10 18C7.80554 18 5.92362 17.2153 4.35417 15.6458C2.78471 14.0764 2 12.1945 2 10C2 7.80554 2.77777 5.93056 4.33333 4.375ZM14.7083 5.29167C13.4028 3.9861 11.8333 3.33333 10 3.33333C8.16666 3.33333 6.59723 3.9861 5.29167 5.29167C3.9861 6.59723 3.33333 8.16666 3.33333 10C3.33333 11.8333 3.9861 13.4028 5.29167 14.7083C6.59723 16.0139 8.16666 16.6667 10 16.6667C11.8333 16.6667 13.4028 16.0139 14.7083 14.7083C16.0139 13.4028 16.6667 11.8333 16.6667 10C16.6667 8.16666 16.0139 6.59723 14.7083 5.29167ZM9.33333 5.33333C9.33333 4.96514 9.63181 4.66667 10 4.66667C10.3682 4.66667 10.6667 4.96514 10.6667 5.33333V9.33333H13.3333C13.7015 9.33333 14 9.63181 14 10C14 10.3682 13.7015 10.6667 13.3333 10.6667H9.37954C9.35402 10.6667 9.33333 10.646 9.33333 10.6205V5.33333Z',
              title: 'product_review_comments.modal.content.time',
              condition: $scope.reviewRewardCondition.deadline_days,
              hint: 'product_review_comments.modal.content.time_hint',
              noLimit: 'product_review_comments.modal.content.no_limit.time',
              params: {
                deadline_days: $scope.reviewRewardCondition.deadline_days,
              },
            },
            {
              svgPath:
                'M16.4941 3C17.3262 3 18 3.68981 18 4.54102V15.459C18 16.3102 17.3262 17 16.4941 17H3.50586C2.67416 17 2 16.3101 2 15.459V4.54102C2 3.68993 2.67416 3 3.50586 3H16.4941ZM3.15918 13.1143V15.459C3.15918 15.6548 3.31449 15.8135 3.50586 15.8135H16.4941C16.6858 15.8135 16.8408 15.655 16.8408 15.459V14.7119L13.5723 11.29L11.6523 13.2197C11.4273 13.4459 11.0236 13.4594 10.7783 13.2598L10.7324 13.2168L6.89551 9.29004L3.15918 13.1143ZM3.50586 4.18652C3.31449 4.18652 3.15918 4.34518 3.15918 4.54102V11.5342L6.43359 8.18359C6.6584 7.95348 7.06703 7.93955 7.31348 8.14258L7.35742 8.18359L11.1982 12.1143L13.123 10.1797C13.3506 9.95098 13.7608 9.94095 14.0049 10.1465L14.0479 10.1875L16.8408 13.1104V4.54102C16.8408 4.34497 16.6858 4.18652 16.4941 4.18652H3.50586ZM14 6C14.552 6 15 6.448 15 7C15 7.552 14.552 8 14 8C13.448 8 13 7.552 13 7C13 6.448 13.448 6 14 6Z',
              title: 'product_review_comments.modal.content.img',
              condition: $scope.reviewRewardCondition.picture_upload,
              hint: 'product_review_comments.modal.content.img_hint',
              noLimit: 'product_review_comments.modal.content.no_limit.img',
              params: {},
            },
          ];
          const modal = $uibModal.open({
            templateUrl: require('../../../../../../public/themes/shared/product_review_comments/templates.product_review_comments_modal.html'),
            windowClass: 'product-review-comments-modal',
            scope: newScope,
            keyboard: false,
          });
          newScope.closeModal = function () {
            modal.close();
          };
        };
      },
    };
  },
]);
